import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appRipple]'
})
export class RippleDirective {
    private static stylesInjected = false;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.injectStyles();
    }

    private injectStyles() {
        if (RippleDirective.stylesInjected) return;
        const style = this.renderer.createElement('style');
        style.textContent = `
            .ripple-effect {
                position: absolute;
                border-radius: 50%;
                background-color: rgba(0, 0, 0, 0.3);
                pointer-events: none;
                transform: scale(0);
                animation: ripple-animation 600ms linear;
                opacity: 0.75;
                will-change: transform, opacity;
                z-index: 9999;
            }
            @keyframes ripple-animation {
                to {
                    transform: scale(4);
                    opacity: 0;
                }
            }
            /* Make sure the button is positioned relative for ripple absolute positioning */
            [appRipple] {
                position: relative;
                overflow: hidden;
            }
        `;
        this.renderer.appendChild(document.head, style);
        RippleDirective.stylesInjected = true;
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        const button = this.el.nativeElement;
        const ripple = this.renderer.createElement('span');

        this.renderer.addClass(ripple, 'ripple-effect');
        this.renderer.appendChild(button, ripple);

        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = event.clientX - rect.left - size / 2;
        const y = event.clientY - rect.top - size / 2;

        this.renderer.setStyle(ripple, 'width', size + 'px');
        this.renderer.setStyle(ripple, 'height', size + 'px');
        this.renderer.setStyle(ripple, 'left', x + 'px');
        this.renderer.setStyle(ripple, 'top', y + 'px');

        ripple.addEventListener('animationend', () => {
            this.renderer.removeChild(button, ripple);
        });
    }
}
